import * as R from 'ramda';

const getPairedQuestion = (question, questions) =>
  question.meta.pairedQuestionUuid ? R.find(q => question.meta.pairedQuestionUuid === q.uuid, questions) : null;

export default getPairedQuestion;
